import type { BlogNavigationProps } from '@we-make-websites/ui-lib';
import type { BlogNavFragment } from 'lib/contentful/__generated__/ModuleBlogNavigation';

export const formatModuleBlogNavigation = (
  entryContent: BlogNavFragment
  // eslint-disable-next-line sonarjs/cognitive-complexity
): BlogNavigationProps & { heading?: string } => {
  const blogNavItems: BlogNavigationProps['navigation'] = [];

  if (entryContent.blogNavItemsCollection?.items) {
    entryContent.blogNavItemsCollection.items.forEach((item) => {
      if (!item) {
        return;
      }

      /**
       * Formats the slide props.
       */
      const formattedItem = {
        image: {
          height: item.image?.height ?? 0,
          width: item.image?.width ?? 0,
          url: item.image?.url ?? '',
          title: item.image?.title ?? '',
        },
        title: item.title ?? '',
        path: item.path ?? '',
        newTab: item.openLinkInNewTab ?? false,
      };

      blogNavItems.push(formattedItem);
    });
  }

  return {
    heading: entryContent.heading ?? '',
    navigation: blogNavItems,
  };
};
